<template>
  <v-container fluid>
    <v-combobox
      v-model="users"
      :items="items"
      :search-input.sync="search"
      label="Члены группы"
      item-value="id"
      multiple
      persistent-hint
      small-chips
      no-filter
    >
      <template v-slot:selection="{ attrs, item, parent}">
        <v-chip
          label
          outlined
          v-bind="attrs"
        >
          <span class="pr-2">
            {{ item.email }}
          </span>
          <v-icon
            small
            @click="parent.selectItem(item)"
          >
            mdi-close
          </v-icon>
        </v-chip>
      </template>
      <template v-slot:item="{ item }">
        {{ item.email }}
      </template>

      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Введите email для поиска
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-combobox>
  </v-container>
</template>
<script>
import { UsersList } from '@/graphql/users'
import { TransformFields } from '@/mixins/fields'
  export default {
        apollo: {
            UsersList: {
            query: UsersList,
            variables () {
                return {
                    search: this.search
                }
            },
            result ({ data }) {
                const items = []
                for (const key in data.IdentityList.identity) {
                const item = data.IdentityList.identity[key]
                const fields = TransformFields(item.Fields)
                fields.id = item.Id
                items.push(fields)
                }
                this.items = Object.assign(items)
            },
             update: data => data.IdentityList
            }
        },
      props: {
          users_default: {
              type: Array
          },
          openDialog: {
            type: Boolean
          }
      },
    data: () => ({
      users: [],
      items: [],
      search: null
    }),
    watch: {
      openDialog (val) {
        if (val) {
          this.users = []
          if (this.users_default !== undefined) {
             this.users = this.users_default
          }
        }
      },
        users (val) {
             this.$emit('update-users', val)
        },
      search (val) {
        if (val && val.length > 3) {
          this.$apollo.queries.UsersList.refetch()
        }
      }
    }
  }
</script>
